require("!!/Desenvolvimento/PMP/painel/node_modules/script-loader/addScript.js")(require("!!/Desenvolvimento/PMP/painel/node_modules/raw-loader/index.js!/Desenvolvimento/PMP/painel/node_modules/jquery-slimscroll/jquery.slimscroll.js"))


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/script-loader!/Desenvolvimento/PMP/painel/~/jquery-slimscroll/jquery.slimscroll.js
// module id = ../../../../script-loader/index.js!../../../../jquery-slimscroll/jquery.slimscroll.js
// module chunks = 36